import React, { useState, useEffect } from 'react';
import api from "../../../services/api";
import Button from "../../controls/buttons/Button";
import app from "../../../services/base";
import Grid from '@material-ui/core/Grid';
import Checkbox from '@mui/material/Checkbox';
import graph_icon from '../../../assets/graph-icon.png';
import { StudentDialog } from '../../../components/modal';
import Chart from "react-apexcharts";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


import "./Subjects.scss";
import { MenuItem, TextField } from '@mui/material';
import { Avatar } from '@material-ui/core';


function SubjectsDashboard({ eventId, attenders }) {
    const [currentSubject, setCurrentSubject] = useState(null);
    const [SubjectList, setSubjectList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [studentFilter, setStudentFilter] = useState('');
    const [maxClasses, setMaxClasses] = useState();
    const [studentchecks, setStudentChecks] = useState(0);
    const [checkedStudents, setCheckedStudents] = useState([]);
    const [studentsList, setStudentsList] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [studentsData, setStudentsData] = useState([]);
    const [studentTimeMinMax, setStudentTimeMinMax] = useState([-1, -1, -1]);
    const [studentDownMinMax, setStudentDownMinMax] = useState([-1, -1, -1]);
    const [studentWatchedMinMax, setStudentWatchedMinMax] = useState([-1, -1, -1]);
    const [filesDownMinMax, setFilesDownMinMax] = useState([-1, -1, -1]);
    const [minMaxIdList, setMinMaxIdList] = useState([]);
    const [filteredStudentsList, setFilteredStudentsList] = useState([]);
    const [open, setOpen] = useState(false);
    const [noStudents, setNoStudents] = useState(false);
    const [modalAction, setModalAction] = useState({});


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });


    const getChartInfo = async () => {
        if (eventId) {

        }
    }

    const getDisciplinas = async () => {
        setShowLoading(true);

        let communities;

        if (eventId) {
            communities = await app
                .firestore()
                .collection("connections")
                .where("eventId", "==", eventId)
                .where("chatType","==","GroupChat")
                .get();
        }

        let communityList = [];
        let communityListIds = [];
        let subjectList = []

        if (communities) {
            for (const elem of communities.docs) {

                communityList.push({
                    title: elem.data().groupInfo.title,
                    id: elem.data().id,
                    members: elem.data().users,
                    admin: false
                })
                communityListIds.push(elem.data().id);
            }
        }

        setGroupList(communityList);
        if (communityListIds.length > 0) {

            let subjects;


            subjects = await app
                .firestore()
                .collection("disciplina")
                .where("groupIds", "array-contains-any", communityListIds)
                .get();


            if (subjects) {
                for (const elem of subjects.docs) {

                    subjectList.push({
                        ...elem.data(),
                        lastUpdate: elem.data().lastUpdate.toDate()
                    })
                }
            }

            if (subjectList.length == 0) {
                setStudentsList([]);
                setStudentsData([]);


                setCurrentSubject(null);
                setMaxClasses(0);
                setCheckedStudents([]);
                setStudentChecks(0);
            }



            setSubjectList(subjectList);
        }

        setShowLoading(false);
    };

    function searchStudents(text) {
        setStudentFilter(text);
        if (text !== '') {
            const filteredStudentsList = studentsList.filter((item) => {
                return item.name.toLowerCase().includes(text);
            });
            setFilteredStudentsList(filteredStudentsList);
        }
        else {
            setFilteredStudentsList(studentsList);
        }

    }

    async function ChangeSubject(id) {
        let subject = SubjectList[id];
        let members = [];
        let studentData = [];

        subject.groupIds.forEach((groupId) => {
            let group = groupList.find((g) => { return (g.id == groupId) })
            if (group) {
                members = [...new Set([...members, ...group.members])]
            }

        })

        let memberList = attenders.filter((a) => {
            return (members.includes(a.id))
        })



        let classList = subject.studentData ? subject.studentData.classIds : null;



        //alunos teste

        /*
        if (subject.studentData) {
            subject.studentData.classData[1] = { students: [] }
            subject.studentData.classData[2] = { students: [] }

            for (let i = 0; i < 10; i++) {
                memberList.push({
                    "id": i,
                    "name": "aluno " + i,
                    "photoURL": null
                })
                for (let j = 1; j <= 2; j++) {
                    let filesData;
                    if (j == 1) {
                        filesData = {

                            "4": { numberofDownloads: Math.floor(Math.random() * 10) },
                            "5": { numberofDownloads: Math.floor(Math.random() * 10) },
                            "6": { numberofDownloads: Math.floor(Math.random() * 10) },

                        }

                    }
                    else {
                        filesData = {

                            "7": { numberofDownloads: Math.floor(Math.random() * 10) },
                            "8": { numberofDownloads: Math.floor(Math.random() * 10) },
                            "9": { numberofDownloads: Math.floor(Math.random() * 10) },

                        }
                    }


                    subject.studentData.classData[j].students.push({
                        "timeSpent": Math.floor(Math.random() * 600),
                        "studentID": i,
                        "filesData": filesData,
                        "numberOfVisits": Math.floor(Math.random() * 5),
                        "lastAccess": subject.lastUpdate
                    })
                }
            }
        }
        */




        if (classList) {
            let allClasses = subject.subjectModules.reduce((prev, next) => prev.concat(next.classList), []);
            let filesCounter = []
            await classList.forEach((classId) => {
                let thisClass = allClasses.find((s) => { return (s.classId == classId) })
                let classFiles = thisClass.classFiles.reduce((prev, next) => prev.concat(next), []);
                let totalDownloads = 0;
                if (subject.studentData.classData[classId]) {

                    subject.studentData.classData[classId].students.forEach((student) => {

                        if (studentData[student.studentID]) {
                            totalDownloads = studentData[student.studentID].totalDownloads;
                            for (let i = 0; i < classFiles.length; i++) {

                                if (student.filesData[classFiles[i].id]) {
                                    totalDownloads = totalDownloads + student.filesData[classFiles[i].id].numberofDownloads;
                                    if (filesCounter[classFiles[i].id]) {
                                        filesCounter[classFiles[i].id].total += student.filesData[classFiles[i].id].numberofDownloads;
                                    }
                                    else {
                                        filesCounter[classFiles[i].id] = {
                                            total: student.filesData[classFiles[i].id].numberofDownloads,
                                            name: classFiles[i].name,
                                            id: classFiles[i].id
                                        }
                                    }
                                }
                            }
                            studentData[student.studentID] = {
                                totalClasses: studentData[student.studentID].totalClasses + 1,
                                longestClass: studentData[student.studentID].longestClass < student.timeSpent ? student.timeSpent : studentData[student.studentID].longestClass,
                                shortestClass: studentData[student.studentID].shortestClass > student.timeSpent ? student.timeSpent : studentData[student.studentID].shortestClass,
                                totalClasstime: student.timeSpent + studentData[student.studentID].totalClasstime,
                                totalDownloads: totalDownloads + studentData[student.studentID].totalDownloads,
                                lastAccess: new Date(student.lastAccess) > studentData[student.studentID].lastAccess ? new Date(student.lastAccess) : studentData[student.studentID].lastAccess,
                                numberOfVisits: student.numberOfVisits + studentData[student.studentID].numberOfVisits
                            }

                        }
                        else {
                            totalDownloads = 0;
                            for (let i = 0; i < classFiles.length; i++) {
                                if (student.filesData[classFiles[i].id]) {
                                    totalDownloads = totalDownloads + student.filesData[classFiles[i].id].numberofDownloads;
                                    if (filesCounter[classFiles[i].id]) {
                                        filesCounter[classFiles[i].id].total += student.filesData[classFiles[i].id].numberofDownloads;
                                    }
                                    else {
                                        filesCounter[classFiles[i].id] = {
                                            total: student.filesData[classFiles[i].id].numberofDownloads,
                                            name: classFiles[i].name,
                                            id: classFiles[i].id
                                        }
                                    }
                                }
                            }
                            studentData[student.studentID] = {
                                totalClasses: 1,
                                longestClass: student.timeSpent,
                                shortestClass: student.timeSpent,
                                totalClasstime: student.timeSpent,
                                totalDownloads: totalDownloads,
                                lastAccess: new Date(student.lastAccess),
                                numberOfVisits: student.numberOfVisits
                            }
                        }

                    }

                    )

                }


            })

            filesCounter = filesCounter.filter(n => n);


            let first = false;
            let minTime = 0;
            let maxTime = 0;
            let minDown = 0;
            let maxDown = 0;
            let minFile = 0;
            let maxFile = 0;
            let totalFile = 0;
            let minWatched = 0;
            let maxWatched = 0;
            let totalDown = 0;
            let totalTime = 0;
            let totalWatched = 0;
            let studentCounter = 0;
            let idList = []



            for (let i = 0; i < memberList.length; i++) {
                memberList[i].checked = false
                if (studentData[memberList[i].id]) {
                    if (!first) {
                        first = true;
                        studentCounter = 1;
                        totalDown = studentData[memberList[i].id].totalDownloads;
                        totalTime = studentData[memberList[i].id].totalClasstime;
                        totalWatched = studentData[memberList[i].id].totalClasses;
                        minTime = studentData[memberList[i].id].shortestClass;
                        maxTime = studentData[memberList[i].id].longestClass;
                        minDown = studentData[memberList[i].id].totalDownloads;
                        maxDown = studentData[memberList[i].id].totalDownloads;
                        minWatched = studentData[memberList[i].id].totalClasses;
                        maxWatched = studentData[memberList[i].id].totalClasses;
                        idList = [memberList[i].id, memberList[i].id, memberList[i].id, memberList[i].id, memberList[i].id, memberList[i].id, 0, 0]
                    }
                    else {
                        totalDown += studentData[memberList[i].id].totalDownloads;
                        totalTime += studentData[memberList[i].id].totalClasstime;
                        totalWatched += studentData[memberList[i].id].totalClasses;
                        studentCounter += 1;
                        if (studentData[memberList[i].id].shortestClass < minTime) {
                            minTime = studentData[memberList[i].id].shortestClass;
                            idList[0] = memberList[i].id
                        }
                        if (studentData[memberList[i].id].longestClass > maxTime) {
                            maxTime = studentData[memberList[i].id].longestClass;
                            idList[1] = memberList[i].id
                        }
                        if (studentData[memberList[i].id].totalDownloads < minDown) {
                            minDown = studentData[memberList[i].id].totalDownloads;
                            idList[2] = memberList[i].id
                        }
                        if (studentData[memberList[i].id].totalDownloads > maxDown) {
                            maxDown = studentData[memberList[i].id].totalDownloads;
                            idList[3] = memberList[i].id
                        }
                        if (studentData[memberList[i].id].totalClasses < minWatched) {
                            minWatched = studentData[memberList[i].id].totalClasses;
                            idList[4] = memberList[i].id
                        }
                        if (studentData[memberList[i].id].totalClasses > maxWatched) {
                            maxWatched = studentData[memberList[i].id].totalClasses;
                            idList[5] = memberList[i].id
                        }
                    }

                }
            }

            for (let i = 0; i < filesCounter.length; i++) {
                if (i == 0) {
                    minFile = filesCounter[i].total;
                    maxFile = filesCounter[i].total;
                    totalFile = filesCounter[i].total;
                    idList[6] = i;
                    idList[7] = i;
                }
                else {
                    if (filesCounter[i].total < minFile) {
                        minFile = filesCounter[i].total;
                        idList[6] = i;
                    }
                    if (filesCounter[i].total > maxFile) {
                        maxFile = filesCounter[i].total;
                        idList[7] = i;
                    }
                    totalFile += filesCounter[i].total;
                }

            }


            let medDown = Math.floor(totalDown / studentCounter);
            let medTime = Math.floor((totalTime ) / totalWatched);
            let medWatched = Math.floor(totalWatched / studentCounter);
            let medFile = Math.floor(totalFile / filesCounter.length);

            setStudentTimeMinMax([minTime, maxTime, medTime]);
            setStudentDownMinMax([minDown, maxDown, medDown]);
            setStudentWatchedMinMax([minWatched, maxWatched, medWatched]);
            setFilesDownMinMax([minFile, maxFile, medFile])
            setMinMaxIdList(idList);
            setFileList(filesCounter);
            setStudentsList(memberList);
            setStudentsData(studentData);


            setCurrentSubject(id);
            setMaxClasses(classList.length);
            setCheckedStudents([]);
            setStudentChecks(0);
        }
        else {
            setStudentsList([]);
            setStudentsData([]);
            setCurrentSubject(null);
            setMaxClasses(0);
            setCheckedStudents([]);
            setStudentChecks(0);
            setNoStudents(true)
        }




    }

    function gaugeBar(aulas) {
        let percentage = maxClasses > 0 ? Math.floor(aulas / maxClasses * 100) + '%' : 0;

        return (
            <div className='gaugeBar-parent'>
                <div className='gaugeBar-child' style={{ width: percentage }}></div>
                <label style={{ color: '#333333' }}>{aulas + '/' + maxClasses} <label style={{ color: '#828282' }}>{'(' + percentage + ')'} </label></label>

            </div>
        )

    }

    function checkStudent(id, index) {
        let students = [...checkedStudents];
        let list = [...studentsList];
        list[index].checked = !list[index].checked;
        if (!studentsList[index].checked) {
            students.splice(students.findIndex(i => i.id == id), 1);
            setStudentsList(list)
            setCheckedStudents(students);
            setStudentChecks(studentchecks - 1);
        }
        else {
            students.push(studentsList[index]);
            setStudentsList(list)
            setCheckedStudents(students);
            setStudentChecks(studentchecks + 1);
        }


    }

    function clearChecks() {
        let list = [...studentsList];
        for (let i = 0; i < list.length; i++) {
            list[i].checked = false;
        }
        setCheckedStudents([]);
        setStudentChecks(0)
    }

    function studentsRow() {
        let list = studentFilter == '' ? studentsList : filteredStudentsList;
        if (list.length > 0) {
            return (
                <div className='students-table' style={{ height: '400px' }}>
                    <table className='students-table'>
                        {list.map(({ id, name, photoURL }, index) => {
                            return (
                                <tr className='students-table-row'>
                                    <td style={{ width: '50px' }}>
                                        <Checkbox checked={list[index].checked}
                                            onChange={() => checkStudent(id, index)}
                                            disabled={studentchecks == 4 && !list[index].checked}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }} />
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginLeft: 5, marginRight: 20 }}>

                                                <div style={{ position: 'relative' }} />

                                                <Avatar src={photoURL} />
                                            </div>
                                            {name}
                                        </div>
                                    </td>
                                    <td style={{ minWidth: '100px' }}>
                                        {gaugeBar(studentsData[id] ? studentsData[id].totalClasses : 0)}
                                    </td>

                                </tr>

                            )

                        })}
                    </table>
                </div>


            )
        }
    }

    function formatDate(data) {
        let d = new Date(data);
        return ((d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '/' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '/' + d.getFullYear())
    }

    function secondsToHms(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? h + ("h") : "";
        var mDisplay = m > 0 ? m + ("m") : "";
        var sDisplay = s > 0 ? s + ("s") : "";
        return hDisplay + mDisplay + sDisplay;
    }

    function StudentModal(i) {
        let student = checkedStudents[i];
        return (
            <div>
                <Grid container
                    gap={4}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start">
                    <Grid item xs={12} sx={{ paddingTop: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                            <div style={{ marginLeft: 5, marginRight: 20 }}>

                                <div style={{ position: 'relative' }} />

                                <Avatar src={student.photoURL} />
                            </div>
                            {student.name}
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Maior tempo de conclusão
                            </label>
                            <label className='student-modal-value'>
                                1h40m
                            </label>
                        </div>

                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Menor tempo de conclusão
                            </label>
                            <label className='student-modal-value'>
                                40m
                            </label>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Tempo médio de conclusão
                            </label>
                            <label className='student-modal-value'>
                               60m
                            </label>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Aulas assíncronas vistas
                            </label>
                            <div className='student-modal-value'>
                                5
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Arquivos de materiais baixados
                            </label>
                            <label className='student-modal-value'>
                                4
                            </label>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Data do último acesso
                            </label>
                            <label className='student-modal-value'>
                                30/05/2023
                            </label>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '20px' }}>
                        <div className='student-modal-cell'>
                            <label className='student-modal-label'>
                                Número total de acessos
                            </label>
                            <label className='student-modal-value'>
                                50
                            </label>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }

    function viewStudentDetails() {
        if (studentchecks == 1) {
            return (StudentModal(0))
        }
        else if (studentchecks == 2) {
            return (
                <div className='student-modal-container'>
                    <div style={{ borderRight: "2px solid #DDE2E5" }}>
                        {StudentModal(0)}
                    </div>
                    <div>
                        {StudentModal(1)}
                    </div>
                </div>
            )
        }
        else if (studentchecks == 3) {
            return (
                <>
                    <div className='student-modal-container' style={{ borderBottom: "2px solid #DDE2E5" }}>
                        <div style={{ borderRight: "2px solid #DDE2E5" }}>
                            {StudentModal(0)}
                        </div>
                        <div >
                            {StudentModal(1)}
                        </div>
                    </div>
                    <div className='student-modal-container' >
                        <div style={{ paddingTop: 10 }}>
                            {StudentModal(2)}
                        </div>
                    </div>

                </>

            )
        }

        else if (studentchecks == 4) {
            return (
                <>
                    <div className='student-modal-container' style={{ borderBottom: "2px solid #DDE2E5" }}>
                        <div style={{ borderRight: "2px solid #DDE2E5" }}>
                            {StudentModal(0)}
                        </div>
                        <div >
                            {StudentModal(1)}
                        </div>
                    </div>
                    <div className='student-modal-container' >
                        <div style={{ borderRight: "2px solid #DDE2E5", paddingTop: 10 }}>
                            {StudentModal(2)}
                        </div>
                        <div style={{ paddingTop: 10 }}>
                            {StudentModal(3)}
                        </div>
                    </div>

                </>

            )
        }

    }

    function graphOptions(type) {



        let min;
        let med;
        let max;
        let minId;
        let maxId;
        let minText;
        let medText;
        let maxText;
        let title;

        if (type == 'time') {
            min = 2400;
            max = 6000;
            med = 3600;
            minId = 0;
            maxId = 1;
            minText = 'Menor tempo de conclusão';
            medText = 'Tempo médio de conclusão';
            maxText = 'Maior tempo de conclusão';
            title = 'Tempo de conclusão de aula pelos alunos';
        }
        else if (type == 'down') {
            min = 5;
            max = 16;
            med = 8;
            minId = 2;
            maxId = 0;
            minText = 'Menor número de materiais baixados';
            medText = 'Média de materiais baixados';
            maxText = 'Maior número de materiais baixados';
            title = 'Materiais baixados pelos alunos';

        }
        else if (type == 'watched') {
            min = 2;
            max = 15;
            med = 10;
            minId = 1;
            maxId = 2;
            minText = 'Aluno com menos aulas assistidas';
            medText = 'Média de aulas assíncronas assistidas pelos alunos';
            maxText = 'Aluno(a) com mais aulas assistidas';
            title = 'Aulas gravadas assistidas'
        }
        else if (type == 'file') {
            min = 3;
            max = 15;
            med = 6;
            minId = minMaxIdList[6];
            maxId = minMaxIdList[7];
            minText = 'Material com menor número de downloads';
            medText = 'Média de materiais baixados por aluno';
            maxText = 'Material com menor número de downloads';
            title = 'Quantidade de materiais baixados';

        }

        let categories;

        if (type == 'file') {
            categories = [maxId >= 0 ? fileList[maxId].name : '-', 'Média da Disciplina', minId >= 0 ? fileList[minId].name : '-'];
        }
        else {
            categories = [maxId >= 0 ? studentsList[maxId].name : '-', 'Média da Disciplina', minId >= 0 ? studentsList[minId].name : '-'];
        }


        let series = [{
            data: [max, med, min]
        }]
        let options = {

            colors: ['#046D7D', '#17A2B8', '#4ED3E8'],
            chart: {
                type: 'bar',
                height: 350

            },
            plotOptions: {
                bar: {
                    distributed: true,
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                },
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: categories,
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return type == 'time' ? secondsToHms(val) : val;
                    }
                }
            },
            fill: {
                opacity: 1
            }
        };


        return (
            <div>
                <label className='dashboard-graph-title'>
                    {title}
                </label>
                <div className="mixed-chart">
                    <Chart
                        options={options}
                        series={series}
                        type="bar"
                    />
                </div>
                <div className='student-modal-container' style={{ borderBottom: "2px solid #DDE2E5" }}>
                    <div className='student-modal-result' style={{ borderRight: "2px solid #DDE2E5" }}>
                        <label className='dashboard-graph-label'>
                            {maxText}
                        </label>
                        <div className='dashboard-graph-icon-label'>

                            {type != "file" && <Avatar src={maxId >= 0 ? studentsList[maxId].photoURL : null} />}
                            <div>
                                <label className='dashboard-graph-label'>
                                    {maxId >= 0 ? (type == "file" ? fileList[maxId].name : studentsList[maxId].name) : '-'}
                                </label>
                                <label className='dashboard-graph-value-label max-color'>
                                    {type == 'time' ? secondsToHms(max) : max}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='student-modal-result'>
                        <label className='dashboard-graph-label'>
                            {minText}
                        </label>
                        <div className='dashboard-graph-icon-label'>
                            {type != "file" && <Avatar src={minId >= 0 ? studentsList[minId].photoURL : null} />}
                            <div>
                                <label className='dashboard-graph-label'>
                                    {minId >= 0 ? (type == "file" ? fileList[minId].name : studentsList[minId].name) : '-'}
                                </label>
                                <label className='dashboard-graph-value-label min-color'>
                                    {type == 'time' ? secondsToHms(min) : min}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='student-modal-container' >
                    <div className='student-modal-result'>
                        <label className='dashboard-graph-label'>
                            {medText}
                        </label>
                        <label className='dashboard-graph-value-label min-color'>
                            {type == 'time' ? secondsToHms(med) : med}
                        </label>
                    </div>
                </div>
            </div>

        )
    }


    useEffect(() => {
        if (eventId) {
            setStudentsList([]);
            setStudentsData([]);
            setCurrentSubject(null);
            setMaxClasses(0);
            setCheckedStudents([]);
            setStudentChecks(0);
            getDisciplinas();}
        return () => { }
    }, [eventId]);

    useEffect(() => {
        if (currentSubject && eventId) getChartInfo();
        return () => { }
    }, [currentSubject]);

    return (
        <div className='dashboard-subjects-container'>
            {showLoading &&
                <div className='container-chart-loader'>
                    <div class="lds-chart"><div></div><div></div><div></div></div>
                </div>
            }
            <Snackbar open={noStudents} autoHideDuration={6000} onClose={() => setNoStudents(false)}>
                <Alert onClose={() => setNoStudents(false)} severity="warning" sx={{ width: '100%' }}>
                    A Disciplina selecionada não possui aulas ou ainda não foi visualizada por nenhum aluno
                </Alert>
            </Snackbar>
            <StudentDialog open={open} {...modalAction} />
            <Grid container direction="row"
                justifyContent="flex-start"
                alignItems="flex-start">
                <Grid item xs={6}>
                    <div className='dashboard-subjects-left-grid'>
                        <TextField
                            select
                            className="Dashboard-subject-select"
                            label="Disciplina"
                            value={currentSubject}
                            onChange={event => ChangeSubject(event.target.value)}
                            disabled={SubjectList.length == 0}
                        >
                            <MenuItem value={null} sx={{ display: 'none' }}> Selecione a Disciplina </MenuItem>
                            {SubjectList.map((subject, index) => <MenuItem key={index} value={index}>{subject.name}</MenuItem>)}
                        </TextField>
                        <div className='dashboard-list-container'>
                            <div className="dashboard-input-label">
                                <label className="dashboard-input-label-text">Alunos da disciplina</label>
                                <div className="search-students">
                                    <input
                                        type="text"
                                        placeholder="Buscar alunos"
                                        value={studentFilter}

                                        onChange={(e) => {
                                            searchStudents(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className='dashboard-list-header'>
                                    <label className="dashboard-list-label-header">
                                        Alunos <label className='small'>(Selecione até 4 para visualizar seus detalhes)</label>
                                    </label>
                                    <label className="dashboard-list-label-header">
                                        Aulas concluídas
                                    </label>

                                </div>

                            </div>
                            <div className='dashboard-list-rows'>
                                {studentsRow()}
                            </div>
                            <div className='dashboard-list-btn'>
                                <label onClick={() => clearChecks()}>
                                    <Button className={'gray-button'}>
                                        <span style={{ lineHeight: '24px' }}>Limpar Seleção</span>
                                    </Button>
                                </label>
                                <label onClick={() => {
                                    setModalAction({
                                        title: "Desempenho individual do(a) aluno(a)",
                                        content: viewStudentDetails(),
                                        size: studentchecks == 1 ? 'small' : 'big',
                                        actionCancel: () => setOpen(false),
                                    });
                                    setOpen(true);
                                }}>
                                    <Button className={'light-blue-button'} disabled={studentchecks == 0}>
                                        <img src={graph_icon} style={{ height: '24px', width: '24px' }} />
                                        <span>Visualizar Detalhes</span>
                                    </Button>
                                </label>

                            </div>

                        </div>
                    </div>


                </Grid>
                <Grid item xs={6}>
                    <div className='dashboard-graph-container'>
                        {(currentSubject != null && maxClasses > 0) && graphOptions('time')}
                    </div>
                    <div className='dashboard-graph-container'>
                        {(currentSubject != null && maxClasses > 0) && currentSubject != null && graphOptions('down')}
                    </div>
                    <div className='dashboard-graph-container'>
                        {(currentSubject != null && maxClasses > 0) && currentSubject != null && graphOptions('file')}
                    </div>
                    <div className='dashboard-graph-container'>
                        {(currentSubject != null && maxClasses > 0) && currentSubject != null && graphOptions('watched')}
                    </div>

                </Grid>

            </Grid>
        </div>
    )
}

export default SubjectsDashboard;